import React, { useState } from "react";
import { TextField, InputAdornment, Button } from "@mui/material";

interface PromotionalCodeProps {
    value: string;
    placeholder?: string;
    label?: string;
    onGenerate: (newCode: string) => void;
    onChange: (newCode: string, isValid: boolean) => void;
}

// Function to generate a random alphanumeric code of a given length
const generateCode = (length: number = 8): string => {
    const characters = "ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
    let code = "";
    for (let i = 0; i < length; i++) {
        code += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    return code;
};

// Function to validate manual input: Allow only uppercase letters & numbers, max length 8
const validateInput = (input: string): string => {
    return input.toUpperCase().replace(/[^A-Z0-9]/g, "").slice(0, 12);
};

const PromotionalCode: React.FC<PromotionalCodeProps> = ({ value, label = "Enter code or generate", onGenerate, onChange }) => {
    const [errorMessage, setErrorMessage] = useState("");

    // Handles manual input change with validation
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        const validatedValue = validateInput(event.target.value);
        const hasError = validatedValue.length < 5;
        onChange(validatedValue, hasError); 

        if (hasError) {
            setErrorMessage("Coupon code must be at least 5 characters long.");
        } else {
            setErrorMessage("");
        }
    };

    // Handles the generation of a new promotional code
    const handleGenerate = () => {
        const newCode = generateCode();
        onGenerate(newCode);
        setErrorMessage(""); // Clear error when generating new code
    };

    return (
        <TextField
            label={label}
            value={value}
            onChange={handleChange} 
            error={Boolean(errorMessage)}
            helperText={errorMessage} 
            InputProps={{
                sx: { fontWeight: "bold" },
                endAdornment: (
                    <InputAdornment position="end">
                        <Button
                            variant="contained"
                            color="secondary"
                            size="small"
                            onClick={handleGenerate}
                        >
                            Generate
                        </Button>
                    </InputAdornment>
                ),
            }}
            inputProps={{ maxLength: 12, style: { color: "#424242" } }}
            fullWidth
            color="primary"
        />
    );
};

export default PromotionalCode;
